<template>
	 <v-container style="padding: 0;">
		 <v-sheet class="d-flex">
			 <div style="width: 260px;">
				 <v-file-input @change="fileSelected" :label="title" v-model="upload.files" :rules="upload.rules"
				 	placeholder="请选择图片" prepend-icon="mdi-camera" accept="image/png, image/jpeg" dense
				 	outlined small-chips />
			 </div>
			 <div class="pl-2">
				 <v-progress-circular v-if="upload.percent > 0 " color="success" size="40" width="2"
				 	v-model="upload.percent">
				 	{{ upload.percent }}%
				 </v-progress-circular>
			 </div>
			 <div class="ml-2 mt-n2">
				<v-avatar rounded v-if="upload.key">
					<v-img :src="imgPrev + upload.key + imgSize50" width="50" height="50"></v-img>
				</v-avatar>
			</div>
		 </v-sheet>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	import global from "../config/global"
	import * as qiniu from 'qiniu-js'
	import storage from "../config/storage"
	export default {
		name:"upload-photo",
		props: {
			show:{
				type:Boolean,
				default:false
			},
			title:{
				type:String,
				default:"上传图片"
			},
			previewImg:{
				type:String,
				default:""
			}
		},
		watch:{
			show(newVal,oldVal){
				console.log("upload photo show=",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					// 先清空
					this.clearUpload();
					// 有预览图 显示预览
					console.log("previewImg",this.previewImg);
					if(this.previewImg){
						this.upload.key = this.previewImg;
					}
				}
			}
		},
		data(){
			return {
				imgPrev:global.config.imgPre,
				imgSize50:global.config.imgSize50,
				hideShow:this.show,
				upload: {
					rules: [
						value => !value || value.size < 4000000 || '图片大小不能超过4M!',
					],
					files: null, // 多选文件用[]
					pre: "assets/img/",
					percent: 0,
					key: "" // 全路径
				},
				// 上传的监视事件
				observe: {
					next: this.onNext,
					error: this.onError,
					complete: this.onComplete
				},
			}
		},
		mounted() {
			console.log("upload photo mounted");
			if(this.previewImg){
				this.upload.key = this.previewImg;
			}
		},
		methods:{
			fileSelected(file) {
				this.uploadFile(file);
			},
			clearUpload() {
				this.upload.files = null;
				this.upload.key = "";
				this.upload.percent = 0;
			},
			onNext(res) {
				this.upload.percent = res.total.percent.toFixed();
			},
			onComplete(res) {
				console.log("上传图片成功:",res);
				// 上传完成 显示缩略图
				this.upload.key = res.key;
				this.$emit("success",res);
			},
			onError(err) {
				this.$noty.error("上传失败：" + err.message);
			},
			uploadFile(file) {
				const that = this;
			
				if (file) {
					const indexOfSuffix = file.name.lastIndexOf(".");
					//文件后缀
					const suffix = indexOfSuffix >= 0 ? file.name.substr(indexOfSuffix) : "";
					// 上传的文件名
					const filename = utils.uuid() + suffix;
					// 上传的key
					const key = this.upload.pre  + filename;
				
			
					let uploadToken = storage.getUploadImgToken();
					if (!uploadToken) {
						this.$noty.error("上传失败,上传凭证已失效，请联系管理员");
						return;
					}
					
					// 请求上传的token 然后上传到七牛
					const putExtra = {
						fname: "",
						params: {},
						mimeType: null
					};
					const config = {
						useCdnDomain: true,
						region: qiniu["region"].z2
					};
					let observable = qiniu["upload"](file, key, uploadToken, putExtra, config);
					observable.subscribe(this.observe);
				}
			},
		}
	}
	
</script>

<style>
</style>
